import { LocationStrategy, CommonModule } from '@angular/common';
import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CookieService } from 'ngx-cookie-service';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import { filter } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { CacheService } from 'src/app/services/cache.service';
import { CommonValues } from 'src/app/services/commonValues';
import { FormValidation } from 'src/app/services/FormValidation';
import { JobService } from 'src/app/services/job.service';
import { SocketService } from 'src/app/services/socket.service';
import { SocketServiceStream } from 'src/app/services/SocketServiceStream';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-user-classification',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule, NgbModule, ImageCropperModule],
  templateUrl: './user-classification.component.html',
  styleUrls: ['./user-classification.component.scss']
})
export class UserClassificationComponent extends FormValidation implements OnInit {
  active = 1;
  photoId: any;
  img;
  userId: any;
  userClassificationForm: UntypedFormGroup

  constructor(private cookieService: CookieService,
    private api: ApiService,
    private commonValues: CommonValues,
    private modalService: BsModalService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private util: UtilService,
    private route: ActivatedRoute,
    private cache: CacheService,
    private location: LocationStrategy,
    private _socket: SocketService,​
    private _socket_stream: SocketServiceStream,
    private jobService: JobService
  ) {
    super()
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
   });

   this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
    // Check if the navigation is triggered by the back button
    if (event.navigationTrigger === 'popstate') {
      console.log("back clicked");
      // Perform your action here, like showing a dialog or staying on the same page
      // For example, to stay on the same page, you might do nothing or navigate to the current route
    }
  });


}


    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
      history.pushState(null, null, window.location.href); // Push on popstate event
    }

  ngOnInit() {
    console.log('=== UserClassificationComponent ngOnInit START ===');

    // Initialize form FIRST before any async operations that might use it
    this.userClassificationForm = this.fb.group({
      firstName: [null, [Validators.required, Validators.pattern(this.FIRST_Name.pattern)]],
      lastName: [null, [Validators.required, Validators.pattern(this.LAST_NAME.pattern)]],
      email: null,
      purpose: null,
      photo: null, 
      userType: null,
      clientType: null
    });
    console.log('Form initialized:', this.userClassificationForm);

    const userType = localStorage.getItem('userType');
    console.log('userType from localStorage:', userType);

    const data: any = {};
    data.userId = this.userId;
    if (userType && userType !== "undefined" && userType !== "null") {
      console.log('Redirecting to landingPage because userType exists');
      this.router.navigate(['landingPage']);
      return; // Exit early if redirecting
    }

    this.route.queryParams.subscribe((prevData) => {
      console.log('queryParams received:', prevData);
      this.userId = prevData.userId;
      this.source = prevData.source;
      console.log('userId set to:', this.userId);
      localStorage.setItem("userId", this.userId);
      this.cookieService.set("userId", this.userId);
      this.cache.setValue("userId", this.userId);
      this.getData();
    });

    console.log('=== UserClassificationComponent ngOnInit END ===');
  }

  get e() {
    return this.userClassificationForm.controls
  }

  prompt() {
    // this.userClassificationForm.get('firstName').markAsTouched()
    // this.userClassificationForm.get('firstName').updateValueAndValidity()
    // this.userClassificationForm.get('lastName').markAsTouched()
    // this.userClassificationForm.get('lastName').updateValueAndValidity()
    Swal.fire({
      icon: "info",
      title: "None Selected",
      text: 'Select any options on how you will use GigSumo',
      showConfirmButton: false,
      timer: 4000,
    })
  }

  prompt1() {
    Swal.fire({
      icon: "info",
      title: "None Selected",
      text: 'Select your business classification.',
      showConfirmButton: false,
      timer: 4000,
    })
  }

  getInitialstwo(firstname: string,lastname: string): string {
    return this.jobService.getInitialsparam(firstname,lastname);
  }

  getColortwo(firstname: string,lastname: string): string {
    return this.jobService.getColorparam(firstname,lastname);
  }

  getTextColor(firstname: string,lastname: string): string {
    return this.jobService.getTextColor(firstname,lastname);
  }

  source: any;
  profileId: any = null;
  firstName: any;
  lastName: any;
  getData() {
    console.log('=== getData() called with userId:', this.userId);
    this.util.startLoader();
    this.api.query("user/" + this.userId).subscribe((res) => {
      console.log('API response received:', res);
      this.util.stopLoader();
      if (res.code == '00000') {
        console.log('API success - patching form with:', {
          firstName: res.firstName,
          lastName: res.lastName,
          email: res.email
        });
        this.userClassificationForm.patchValue({
          firstName: res.firstName,
          lastName: res.lastName,
          email: res.email,
          userId: this.userId,
          purpose: null,
          clientType: null,
        });
        this.firstName = res.firstName;
        this.lastName = res.lastName;
        console.log('firstName/lastName set:', this.firstName, this.lastName);
        if (res.photo) {
          this.photoId = res.photo;
          this.img = {
            src: AppSettings.photoUrl + this.photoId,
          };
        }

        if (res.profileId != null) {
          this.profileId = res.profileId;
        }
        localStorage.setItem("userName", res.email);
        this.cache.setValue("email", res.email);
        console.log('=== getData() completed successfully ===');
      } else {
        console.error('API returned non-success code:', res.code, res);
      }
    }, (error) => {
      this.util.stopLoader();
      console.error('API error in getData:', error);
    });
  }

  prompt2() {
    Swal.fire({
      icon: "info",
      title: "None Selected",
      text: 'Select your user type.',
      showConfirmButton: false,
      timer: 4000,
    })
  }

  // Navigation validation for nav links
  navigateToStep2(nav: any) {
    if (this.userClassificationForm.value.purpose != null) {
      nav.select(2);
    } else {
      this.prompt();
    }
  }

  navigateToStep3(nav: any) {
    // First check if step 1 is completed
    if (this.userClassificationForm.value.purpose == null) {
      this.prompt();
      return;
    }
    // Check if step 2 is completed with valid userType that should go to step 3
    const userType = this.userClassificationForm.value.userType;
    if (userType === 'RECRUITER' || userType === 'BENCH_RECRUITER' || userType === 'MANAGEMENT_TALENT_ACQUISITION') {
      nav.select(3);
    } else if(userType === 'FREELANCE_RECRUITER' || userType === 'JOB_SEEKER' ){
      console.log('this user does not have 3rd step');
    }else {
      this.prompt2();
    }
  }

  qwe(value) {
   }

  uploadPhotoHere() {
    this.myFileInput.nativeElement.click()
  }
  fileUploadName: any = "";

  modalRef: BsModalRef;
  @ViewChild("myFileInput") myFileInput;
  imageChangedEvent: any = "";
  fileChangeEvent(event, popupName): void {
    this.imageChangedEvent = event;
    if (event.target.files && event.target.files[0]) {
      this.fileUploadName = event.target.files[0].name;

      this.myFileInput.nativeElement.value; //assigning the file through viewchild
      const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      if (!acceptedImageTypes.includes(event.target.files[0].type)) {
        Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
        // this.myFileInput.nativeElement.value = "";
        this.modalRef.hide();
      } else {
        this.PopupServicevlaues(popupName);
      }
    }
  }

  PopupServicevlaues(templatePhoto: TemplateRef<any>) {
    this.modalRef = this.modalService.show(templatePhoto, {
      animated: true,
      backdrop: "static",
      class: "second",
      keyboard: false,
    });
  }


  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }


  fileToUpload: File;
  croppedImage: any = "";
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    //// console.log("this.v-- "+this.croppedImage.name);\
    //// console.log("this.croppedImage-- "+this.croppedImage);

    const byteString = window.atob(
      event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
    );
    // const byteString = window.atob(event.base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });

    this.fileToUpload = new File([blob], this.fileUploadName, {
      type: "image/jpeg",
    });
  }
  count = 0

  data9: any = {}
  imageLoaded() {
    this.util.startLoader()
    this.closePhoto()
    const formData: FormData = new FormData();
    formData.append("file", this.fileToUpload, this.fileUploadName);
    this.api.create("upload/image", formData).subscribe((res) => {
      if (res) {
        setTimeout(() => {
          this.photoId = res.fileId;
          localStorage.setItem('profilePhoto', this.photoId)
          this.util.stopLoader()
          this.img = {
            src: AppSettings.photoUrl + this.photoId,
          };
        }, 2000);
      }

    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while uploading image. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });


  }


  closePhoto() {
    this.modalRef.hide();
    this.fileUploadName = "";
    // this.myFileInput.nativeElement.value = '';
  }

  isLoading: boolean = false;
  passValue(values: any) {
    if (this.isLoading) {
      return; 
    }
    this.isLoading = true; 
    this.util.startLoader();
    const object = {
      clientType: values.clientType,
      userType: values.userType,
      purpose: values.purpose,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      username: values.email,
      photo: this.photoId,
      skipValidation: true,
      firstLogin: true,
      userId: this.userId,
      workExperience: [],
      source: this.source,
    };

    this.api.create('user/saveUser', object).subscribe(
      (res: any) => {
        if (res.code === '00000') {
          localStorage.setItem('userType', values.userType);
          localStorage.setItem('GSSID', res.gigsumoNo);

          const data: any = { showWelcomePost: true };
          setTimeout(() => {
            this.router.navigate(['landingPage'], { queryParams: data });
          }, 2000);
          // keep isLoading=true during the 2s pause before navigation —
          // a re-click here would send a second saveUser with firstLogin:true
          this.util.stopLoader();
        } else {
          Swal.fire({
            icon: 'info',
            title: 'Oops..',
            text: 'Something went wrong. Please try again later.',
            showConfirmButton: false,
            timer: 3000,
          });
          this.finishProcess();
        }
      },
      (err) => {
        console.error('API Error:', err);
        this.finishProcess();
      }
    );
  }


  private finishProcess() {
    this.util.stopLoader();  
    this.isLoading = false; 
  }


  onLogout() {
    this.util.startLoader();
    this.api.onLogout().subscribe((res) => {
      this.util.stopLoader();
      if (res) {
        if (res.code === "00000") {
          this.cookieService.deleteAll();
          let allCookies = document.cookie.split(";");
          if (allCookies) {
            for (let i = 0; i < allCookies.length; i++) {
              document.cookie =
                allCookies[i] + "=;expires=" + new Date(0).toUTCString();
            }
          }
          localStorage.clear();
          this._socket.ngOnDestroy();​
          this._socket_stream.ngOnDestroy();​
          this.router.navigate(["/auth/login"]);
        }
      }
    });
  }


  onItemSelect(item: any) {
    //// console.log(item);
    //// console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    //// console.log(item);
    //// console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    //// console.log(items);
  }
  onDeSelectAll(items: any) {
    //// console.log(items);
  }

  onHidden(): void {
    // console.log('Dropdown is hidden');
  }
  onShown(): void {
    // console.log('Dropdown is shown');
  }
  isOpenChange(): void {
    // console.log('Dropdown state is changed');
  }

}

